(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    // Open
    document.querySelectorAll('.image-block--lightbox').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-lightbox-target');
        var modal = document.getElementById(id);
        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Close (backdrop click or × button)
    document.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        var id = el.getAttribute('data-lightbox-close');
        var modal = document.getElementById(id);
        if (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.image-lightbox.is-open').forEach(function (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
